export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14691.a9b916fb.jpg";